import type { ComponentProps } from 'react'
import { cn } from '#src/cn.ts'

export function ItemGroup({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      data-slot="item-group"
      role="list"
      className={cn('group/item-group flex flex-col', className)}
      {...props}
    />
  )
}
